<template>
  <div class="max-w-1440px mx-auto">
    <top-block :white="white" :title="title">{{ subtitle }}</top-block>
    <div class="flex mb-30px <sm:flex-col">
      <flying-span :timeout="0" block left
        ><parallax-div
          class="
            h-500px
            w-500px
            <lg:h-400px <lg:w-400px
            <800:h-350px <800:w-350px
            <sm:h-300px <sm:w-300px
            flex-none
          "
          ><img
            data-depth="0.2"
            :src="image"
            class="object-cover w-full h-full" /></parallax-div
      ></flying-span>
      <div
        class="w-full relative <sm:px-50px <sm:mt-35px"
        :class="{ 'sm:-ml-60px': overlap }"
      >
        <flying-span :timeout="0" block>
          <slot name="centr_content"></slot>
        </flying-span>
        <div
          class="
            absolute
            bottom-0
            left-0
            w-[calc(100vw-300px)]
            <sm:w-auto <sm:static <sm:mt-40px
          "
        >
          <slot name="abs_content"></slot>
        </div>
      </div>
      <right-menu-button-block class="<sm:hidden" :white="white" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import TopBlock from './TopBlock.vue';
import ParallaxDiv from './ParallaxDiv.vue';
import FlyingSpan from './FlyingSpan.vue';
import RightMenuButtonBlock from './RightMenuButtonBlock.vue';

export default defineComponent({
  name: 'CentralBlock',
  components: {
    TopBlock,
    ParallaxDiv,
    RightMenuButtonBlock,
    FlyingSpan,
  },
  props: {
    white: Boolean,
    overlap: Boolean,
    title: String,
    subtitle: String,
    image: String,
  },
});
</script>

<style>
</style>
